import { PartialNullable } from "../../Extensions";
import { Property } from "../../RadObject";
import { IPropertyEditor, PropertyEditor, PropertyEditorPropertyValues } from "../Controls/PropertyEditor";
import { Schedule } from "./Schedule";
import { NAMESPACE } from "./_Namespace";

export type PropertyEditorSchedulePropertyValues =
    PropertyEditorPropertyValues
    & {
    };

export type PropertyEditorScheduleProperties = {
    [name in keyof PropertyEditorSchedulePropertyValues]: Property<PropertyEditorSchedulePropertyValues[name]>
};

export interface IPropertyEditorSchedule extends IPropertyEditor, PropertyEditorScheduleProperties
{
}

export class PropertyEditorSchedule extends PropertyEditor implements IPropertyEditorSchedule
{
    // #region Static

    public static override classNamespace = NAMESPACE + "PropertyEditorSchedule";
    public static override className = "PropertyEditorSchedule";

    // #region Overrides

    public static override createPropertyDefaults(): PartialNullable<PropertyEditorSchedulePropertyValues>
    {
        return {
            ...super.createPropertyDefaults(),
            ...{
                createEditorControl: () => new Schedule(),
            }
        };
    }

    // #endregion

    // #endregion
}
